/**
 * Contact widget expandable social channels controller
 */

const initContactWidget = () => {
  const widget = document.querySelector('[data-contact-widget]');
  if (!widget) {
    return;
  }

  const trigger = widget.querySelector('[data-contact-trigger]');
  const list = widget.querySelector('[data-contact-list]');
  if (!trigger || !list) {
    return;
  }

  const links = list.querySelectorAll('a');
  let closeTimer = null;

  let openedByClick = false;

  const openList = (byClick = false) => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (byClick) {
      openedByClick = true;
    }
    widget.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-label', 'Сховати канали зв’язку');
    list.setAttribute('aria-hidden', 'false');
    links.forEach((link) => link.setAttribute('tabindex', '0'));
  };

  const closeList = (focusTrigger = false) => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    openedByClick = false;
    if (!widget.classList.contains('is-open')) {
      return;
    }
    widget.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', 'Показати канали зв’язку');
    list.setAttribute('aria-hidden', 'true');
    links.forEach((link) => link.setAttribute('tabindex', '-1'));
    if (focusTrigger) {
      trigger.focus();
    }
  };

  const scheduleClose = () => {
    if (openedByClick) {
      return;
    }
    if (closeTimer) {
      clearTimeout(closeTimer);
    }
    closeTimer = setTimeout(() => {
      closeList();
    }, 220);
  };

  const cancelClose = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const isDesktopHover = () => {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  };

  // Desktop hover expansion & collapse
  widget.addEventListener('mouseenter', () => {
    if (isDesktopHover()) {
      openList(false);
    }
  });

  widget.addEventListener('mouseleave', () => {
    if (isDesktopHover() && !openedByClick) {
      scheduleClose();
    }
  });

  // Click/Tap toggle (mobile & desktop manual toggle)
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    cancelClose();
    if (widget.classList.contains('is-open')) {
      closeList();
    } else {
      openList(true);
    }
  });

  // Keyboard accessibility: open on focus within, close when focus leaves
  widget.addEventListener('focusin', () => {
    cancelClose();
    openList(false);
  });

  widget.addEventListener('focusout', (e) => {
    if (!widget.contains(e.relatedTarget)) {
      if (!openedByClick && (!isDesktopHover() || !widget.matches(':hover'))) {
        closeList();
      }
    }
  });

  // Click outside to close
  document.addEventListener('click', (e) => {
    if (!widget.contains(e.target)) {
      closeList();
    }
  });

  // Escape key closes and returns focus to trigger
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && widget.classList.contains('is-open')) {
      closeList(true);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactWidget);
} else {
  initContactWidget();
}

export default initContactWidget;
